import React, { useState, useEffect } from 'react';
import { Form, Select, Row, Col } from 'antd';
import InputField from '../../../../../common/InputField';
import CommonCheckBox from '../../../../../common/CommonCheckBox';
import SelectOption from '../../../../../common/SelectOption';
import TimeRangePicker from '../../../../../common/TimePicker/TimeRangePicker';
import FieldName from '../../../../../common/FieldName';
import { dailyPricingOptionValidation } from '../../../../../../helper/spaceFormValidation';
import { days } from '../../../../../common/constants';
import {pricePerSeatValidation} from "../../../../../../helper/FeildValidations";
import { useSelector } from 'react-redux';

const WeeklyPricingOption = ({ form, hotdeskIndex, pricingOptionIndex, currency, paymentOptionId, isEdit, values = {} }) => {
  const rules = [
    {
      required: true,
      message: 'Please Fill Input Field!',
    },
  ];
  const [isFullDayAccess, setFullDayAccess] = useState(values?.access24by7 || false);
  const [timePickers, setTimePickers] = useState([{ beginTime: '3:00 am', endTime: '5:00 pm' }]);
  const [selectedDays, setSelectedDays] = useState(isEdit? values.pricingOptions?.map(d=>d.name)|| []:[]);
  const [price, setPrice] = useState(null);
  const days = useSelector((state)=>state.space?.pricingOptionsArray?.data?.filter(days=> days.chargingType==paymentOptionId)[0]?.pricingOptions || []);
  const [dateSelectionOptions, setDateSelectionOptions] = useState(days);

  useEffect(() => {
    setDateSelectionOptions(dailyPricingOptionValidation(days, selectedDays));
  }, [selectedDays]);
  const deselectItems = (item) => {
    setSelectedDays(selectedDays.filter((i) => i !== item));
  };

  const handleFullDayAccess = (e) => {
    setFullDayAccess(e.target.checked)
    setSelectedDays([]);
  }

  return (
    <>
      <Form.Item name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'chargingType']}>
        <FieldName fieldName={'id'} fieldValue={paymentOptionId} />
      </Form.Item>
        <Form.Item name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'chargingTypeDesc']}>
            <FieldName fieldName={'name'} fieldValue={"Weekly"} />
        </Form.Item>

      <h3>Weekly</h3>
      <Row>
        <Col offset={8}></Col>
        <Col span={16}>
          <CommonCheckBox
            name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'access24by7']}
            label={'24/7 Access'}
            handleOnChange={handleFullDayAccess}
            checked={isEdit ? values.access24by7 : false}
          />
        </Col>
      </Row>
      {isFullDayAccess && (<InputField
        name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'amount']}
        label={'Price'}
        rules={pricePerSeatValidation}
        handleOnChange={(e) => setPrice(e.target.value)}
      />)}
      {!isFullDayAccess && (
        <SelectOption
          isMultiple={true}
          // name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'amount']}
          placeholder={'Days'}
          rules={rules}
          label={'Days'}
          values={days}
          handleOnSelect={(days) => setSelectedDays([...selectedDays, days])}
          handleOnDeselect={deselectItems}
          value={selectedDays}
        />
      )}
      {!isFullDayAccess &&
        selectedDays.map((day, index) => (
          <>
            <Form.Item
              label={day}
              name={[
                'events',
                hotdeskIndex,
                'chargings',
                pricingOptionIndex,
                'pricingOptions',
                index,
              ]}
            >
              <TimeRangePicker
                key={index}
                pickers={timePickers}
                setTimePicker={setTimePickers}
                index={index}
                day={day}
                currency={currency}
                seatPrice={price}
                // seatPrice={price}
                initialValue={isEdit && values?.pricingOptions ? values?.pricingOptions[index]  : null}
              />
            </Form.Item>
          </>
        ))}
    </>
  );
};

export default WeeklyPricingOption;
